import React from 'react';
import { PapiBadge } from '@wix/da-types-papi';
import ElementQueries from '@wix/da-shared-react/pkg/ElementQueries';
import BadgeBox from './BadgeBox';
import classnames from 'classnames';

import s from './Badges.scss';

export interface Props {
  items: PapiBadge[];
  className?: string;
  widthBreakpoints?: number[];
}

export class Badges extends React.Component<Props> {
  render() {
    const { items, className, widthBreakpoints } = this.props;
    return (
      <ElementQueries
        className={classnames(s['grid'], className)}
        widthBreakpoints={widthBreakpoints || [640, 800]}
      >
        {items.map((item, i) => (
          <BadgeBox key={i} item={item} className={s['grid-item']} />
        ))}
      </ElementQueries>
    );
  }
}

export default Badges;
